
{
  "fr": {
    "copy": "Copié !"
  }
}
